import React, { useEffect, useState } from "react";

import Radio from "@cayuse/shared-react.components.form.inputs.radio";
import PropTypes from "prop-types";

import { useRuleBuilderContext } from "containers/Rules/context/useRuleBuilderContext";
import { RULE_TYPES } from "globals/constants";
import { useDictionary } from "hooks";

import RuleRowText from "../../RulesRenderer/RuleRowText/RuleRowText";
import styles from "./styles.css";


const defaultDictionary = {
	integrationLabel: "Choose an integration:",
	disclosure: "Outside Interests",
	infoReady: "InfoReady",
};

const IntegrationAction = ({ onActionChange, rule: originalRule, showRTActions }) => {
	const [ rule, setRule ] = useState(originalRule);
	const dictionary = useDictionary("ruleBuilder.actionBuilder");
	const { isDisclosureEnabled } = useRuleBuilderContext();

	const enabledDisclosure = showRTActions && isDisclosureEnabled;

	const handleChange = value => {
		const updatedRule = {
			...rule,
			ruleType: value
		};

		setRule(updatedRule);
		onActionChange(updatedRule);
	};

	useEffect(() => {
		if(enabledDisclosure) {
			handleChange(RULE_TYPES.DISCLOSURE);
		}
	}, [ enabledDisclosure ]);

	useEffect(() => {
		setRule(originalRule);
	}, [ originalRule ]);

	if (rule.isActionEditing) {
		return (
			<div data-component="Rules\List\ComponentBuilder\IntegrationAction" className={styles.integrationAction}>
				<div className={styles.options}>
					<label>{dictionary.integrationLabel ?? defaultDictionary.integrationLabel}</label>
					<Radio
						id={RULE_TYPES.DISCLOSURE}
						name="integrations"
						checked={enabledDisclosure}
						disabled={!enabledDisclosure}
						value={RULE_TYPES.DISCLOSURE}
						className={styles.option}
					>
						{ dictionary.disclosure ?? defaultDictionary.disclosure}
					</Radio>
					<RuleRowText column="action" rule={rule} />
				</div>
			</div>
		);
	}

	return (
		<div data-component="Rules\List\ComponentBuilder\IntegrationAction">
			<RuleRowText column="action" rule={rule} />
		</div>
	);
};

IntegrationAction.propTypes = {
	formType: PropTypes.string,
	isNew: PropTypes.bool,
};

export default IntegrationAction;
